import type { customizableDashboardData } from '../CustomizableDashboard/CustomizableDashboardState';

export const defaultSections: customizableDashboardData = {
  sections: {
    stats: { visible: true, label: 'Home.Stats' },
    'first-steps': { visible: true, label: 'Home.FirstSteps' },
    'latest-updates': { visible: true, label: 'Home.LatestUpdates' },
    'quick-links': { visible: true, label: 'Home.QuickLinks' },
  },
  sectionsOrder: ['stats', 'first-steps', 'latest-updates', 'quick-links'],
};

export type dashboardSection = Record<
  string,
  {
    visible: boolean;
    label: string;
  }
>;
